import { render } from "./AdminPlagesHoraires.vue?vue&type=template&id=772515dc&scoped=true"
import script from "./AdminPlagesHoraires.vue?vue&type=script&lang=js"
export * from "./AdminPlagesHoraires.vue?vue&type=script&lang=js"

import "./AdminPlagesHoraires.vue?vue&type=style&index=0&id=772515dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772515dc"]])

export default __exports__